import { render, staticRenderFns } from "./ProposalComments.vue?vue&type=template&id=d1219002&"
import script from "./ProposalComments.vue?vue&type=script&lang=js&"
export * from "./ProposalComments.vue?vue&type=script&lang=js&"
import style0 from "./ProposalComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VSnackbar,VTextarea})
